/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Nächsten Inhalt ansehen`
};

const en_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `See next content`
};

const es_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Ver el siguiente contenido`
};

const fr_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Voir le contenu suivant`
};

const it_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi il prossimo contenuto`
};

const nl_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Volgende inhoud bekijken`
};

const pt_poi_card__carousel__next_button = /** @type {(inputs: {}) => string} */ () => {
	return `Ver conteúdo seguinte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__carousel__next_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__carousel__next_button", locale)
	if (locale === "de") return de_poi_card__carousel__next_button(inputs)
	if (locale === "en") return en_poi_card__carousel__next_button(inputs)
	if (locale === "es") return es_poi_card__carousel__next_button(inputs)
	if (locale === "fr") return fr_poi_card__carousel__next_button(inputs)
	if (locale === "it") return it_poi_card__carousel__next_button(inputs)
	if (locale === "nl") return nl_poi_card__carousel__next_button(inputs)
	return pt_poi_card__carousel__next_button(inputs)
};